"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDefault = void 0;
var axios_1 = __importDefault(require("axios"));
var i18n_service_1 = require("./i18n.service");
var AppServiceGlobal = /** @class */ (function () {
    function AppServiceGlobal() {
    }
    AppServiceGlobal.prototype.get = function () {
        var app = global.APP;
        if (!app) {
            throw new Error('App instance not found');
        }
        return app;
    };
    AppServiceGlobal.prototype.make = function (createApp) {
        var app = createApp();
        if (!app) {
            throw new Error('App creation failed');
        }
        return app;
    };
    AppServiceGlobal.prototype.create = function (createApp) {
        this.store(this.make(createApp));
        return this.get();
    };
    AppServiceGlobal.prototype.store = function (app) {
        global.APP = app;
    };
    return AppServiceGlobal;
}());
exports.default = AppServiceGlobal;
var AppDefault = /** @class */ (function () {
    function AppDefault(baseUrl) {
        var _a, _b;
        this.environment = (_a = process.env.NODE_ENV) !== null && _a !== void 0 ? _a : '';
        var language = (_b = document.querySelector('html')) === null || _b === void 0 ? void 0 : _b.getAttribute('lang');
        if (!language) {
            language = 'en';
        }
        this.language = language;
        this.http = axios_1.default.create({
            baseURL: baseUrl,
            // auth: {
            //     username: 'api-user@medfyle.com',
            //     password: 'secret',
            // },
            params: {
                api_language: this.language,
            }
        });
        var i18nApiUrl = '/local/api/i18n';
        if (baseUrl) {
            i18nApiUrl = baseUrl + i18nApiUrl;
        }
        var i18nService = new i18n_service_1.I18nApi(this.http, i18nApiUrl);
        this.i18nMessages = i18nService.fetchMessages();
    }
    return AppDefault;
}());
exports.AppDefault = AppDefault;
